import React from 'react';

import Alert from './Components/Alert/index.jsx';
import LoadingOverlay from './Components/LoadingOverlay/index.jsx';
import UserNotificationSetting from './Components/UserNotificationSetting/index.jsx';

import { AjaxService } from './Services/Ajax/index.jsx';


class UserNotificationSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      settings: {},
      changes: false,
      error: null
    };

    this.fetchComplete = this.fetchComplete.bind(this);
    this.fetchError = this.fetchError.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.saveComplete = this.saveComplete.bind(this);
  }

  componentDidMount() {
    AjaxService.fetch('theme:user-notification-settings')
      .then(this.fetchComplete)
      .catch(this.fetchError);
  }

  fetchComplete(result) {
    if (result) {
      this.setState({ settings: result, loading: false });
    } else {
      this.setState({
        error: 'API returned no results. Reload the page to try again.'
      });
    }
  }

  fetchError(error) {
    this.setState({ error: error.message });
  }

  closeAlert() {
    this.setState({ error: null });
  }

  onChange(value, name) {
    this.setState(function(previousState) {
      var newSettings = Object.assign({}, previousState.settings);
      var settingObject = Object.assign({}, newSettings[name]);
      settingObject.value = value;
      newSettings[name] = settingObject;

      return {
        settings: newSettings,
        changes: true
      };
    });
  }

  onSave() {
    this.setState({ loading: true });

    var data = '';
    var settings = this.state.settings;

    data += 'dailyUpdates=' + settings.dailyUpdates.value;
    data += '&monthlyQA=' + settings.monthlyQA.value;
    data += '&memberResources=' + settings.memberResources.value;
    data += '&researchReports=' + settings.researchReports.value;
    data += '&memberDiscounts=' + settings.memberDiscounts.value;

    AjaxService.post('theme:user-notification-settings-update', data)
      .then(this.saveComplete)
      .catch(this.fetchError);
  }

  /**
   * refresh the page once we have successfully saved.
   */
  saveComplete() {
    window.location.reload();
  }

  render() {
    var notificationSettings = [
      {
        'name': 'dailyUpdates',
        'label': 'Collective Shift Daily Posts'
      },
      {
        'name': 'monthlyQA',
        'label': 'Monthly Q&A'
      },
      {
        'name': 'memberResources',
        'label': 'Resources'
      },
      {
        'name': 'researchReports',
        'label': 'Research Reports'
      },
      {
        'name': 'memberDiscounts',
        'label': 'Member Discounts'
      }
    ];

    var settings = [];
    var settingDefault = {
      value: '0',
      options: null
    };
    for (var i = 0; i < notificationSettings.length; i++) {
      var notification = notificationSettings[i];
      var setting = settingDefault;

      if (this.state.settings && this.state.settings[notification.name]) {
        setting = this.state.settings[notification.name];
      }

      settings.push(
        <UserNotificationSetting
          key={i}
          name={notification.name}
          label={notification.label}
          setting={setting}
          onChange={this.onChange}
          disabled={this.state.loading}
        />
      );
    }

    var notificationLayout = [];
    notificationLayout.push(
      <table key="content" className="cs-user-notification-settings">
        <thead>
          <tr className="cs-user-notification-settings-row cs-user-notification-settings-row--header">
            <th scope="col" className="cs-user-notification-settings-row__label">Send me notifications for:</th>
            <th scope="col" className="cs-user-notification-settings-row__value">Email</th>
          </tr>
        </thead>
        <tbody>
          {settings}
        </tbody>
        <tfoot>
          <tr className="cs-user-notification-settings-row cs-user-notification-settings-row--footer">
            <td className="cs-user-notification-settings-row__label">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={! this.state.changes}
                onClick={this.onSave}
              >
                Save
              </button>
            </td>
          </tr>
        </tfoot>
      </table>
    );

    if (this.state.error) {
      notificationLayout.push(
        <Alert key="error" onClose={this.closeAlert}>
          {this.state.error}
        </Alert>
      );
    }


    if (this.state.loading) {
      return (
        <LoadingOverlay>{notificationLayout}</LoadingOverlay>
      );
    } else {
      return notificationLayout;
    }
  }
}


export default UserNotificationSettings;

